import moment from "moment-timezone";
export function StudentAmountModel(item){
    this.id            = item.id;
    this.contract_id   = item.contract_id;
    this.amount        = item.amount;
    this.audit_status  = item.audit_status;
    this.ben_thu_tien  = item.ben_thu_tien;
    this.branch        = item.branch;
    this.contract_id   = item.contract_id;
    this.created_at    = moment(item.created_at).format("DD/MM/YYYY HH:mm");
    this.nguoi_tao     = item.nguoi_tao;
    this.phone         = item.phone;
    this.referenceCode = item.referenceCode;
    this.status_string = item.status_string;
    this.transactionId = item.transactionId;
    this.user_id       = item.user_id;
    this.user_name     = item.user_name;
    this.audit_date     = moment(item.audit_date).format("DD/MM/YYYY HH:mm");
    this.audit_note     = item.audit_note;
}